import switchLang from "@/helpers/switchLanguage";

interface Language { name: string; imageName: string }
const languageNames = ['en', 'se', 'no', 'is'] as const;
export type LanguageCode = typeof languageNames[number];

export default {
  methods: {
    getName(name: LanguageCode): Language {
      const Languages: Record<LanguageCode, Language> = {
        en: {
          name: `${switchLang[localStorage.langType].langSwitcher.english} Language`,
          imageName: "flag-uk.png",
        },
        se: {
          name: `${switchLang[localStorage.langType].langSwitcher.swedish} Language`,
          imageName: "flag-sv.png",
        },
        no: {
          name: `${switchLang[localStorage.langType].langSwitcher.norwegian} Language`,
          imageName: "flag-no.png",
        },
        is: {
          name: `${switchLang[localStorage.langType].langSwitcher.icelandic} Language`,
          imageName: "flag-is.png",
        }
      };
      return Languages[name];
    },
  }
};
